import xmlServiceervice from "../../services/xmlService";
import {
      XML_ADD_REQUEST,
      XML_ADD_FAILURE,
      XML_ADD_SUCCESS,
      XML_GET_FAILURE,
      XML_GET_REQUEST,
      XML_GET_SUCCESS,
      PROVIDER_GET_REQUEST,
      PROVIDER_GET_FAILURE,
      PROVIDER_GET_SUCCESS
     } from "./actionTypes";

export const fetchProvider = () => {
  return async (dispatch) => {
    dispatch({ type: PROVIDER_GET_REQUEST });
    try {
      const response = await xmlServiceervice.fetchProvider();
      const { data } = response;
      dispatch({ type: PROVIDER_GET_SUCCESS, payload: data });
      return data; 
    } catch (error) {
      dispatch({ type: PROVIDER_GET_FAILURE, error: error.message });
      return Promise.reject(error); 
    }
  };
};


export const fetchProductProvider = (authUserId,token) => {
   
    return async (dispatch) => {
      dispatch({ type: XML_GET_FAILURE });
      try {
        const response = await xmlServiceervice.fetchProductsProvider(authUserId,token);
        const { data } = response;
        dispatch({ type: XML_GET_SUCCESS, payload: data });
        return data; 
      } catch (error) {
        dispatch({ type: XML_GET_REQUEST, error: error.message });
        return Promise.reject(error); 
      }
    };
  };

  export const addProductProvider = (providerData,token) => {
    return async (dispatch) => {
      dispatch({ type: XML_ADD_REQUEST });
      try {
        const response = await xmlServiceervice.addProductProvider(providerData,token);
        const { data } = response;
        dispatch({ type: XML_ADD_SUCCESS, payload: data });
        return data; 
      } catch (error) {
        dispatch({ type: XML_ADD_FAILURE, error: error.message });
        return Promise.reject(error); 
      }
    };
  };
